import { render } from "./SubscriptionStatement.vue?vue&type=template&id=37571b62"
import script from "./SubscriptionStatement.vue?vue&type=script&lang=js"
export * from "./SubscriptionStatement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__